import { NON_BREAKING_SPACE_CHARACTER } from '../constants';

/**
 * Replaces breaking spaces in the given string with non-breaking spaces.
 * @param value A string containg breaking space to be replaced
 * @returns Non-breakable string
 */
export function makeSpacesNonBreakable(value) {
  return value.replaceAll(' ', NON_BREAKING_SPACE_CHARACTER);
}
//# sourceMappingURL=makeSpacesNonBreakable.js.map